<template>
  <div>
    <div v-if="showSuccessBanner" class="success-banner">
      <InfoIcon class="icon" />
      <span>{{ t('account.orders.invoiceRequestSuccess') }}</span>
      <ClosingIcon class="close" @click="showSuccessBanner = false" />
    </div>

    <AccountWrapper class="content">
      <template #title>{{ t('general.titles.account-orders') }}</template>

      <div v-if="isLoading">Loading...</div>
      <div v-else-if="error">Error: {{ error.message }}</div>
      <template v-else>
        <AccountOrder
          v-for="order in orders"
          :key="order.id"
          :order="order"
          is-meta-visible
          class="mb-2"
          @invoice-success="handleInvoiceSuccess"
        />
      </template>
    </AccountWrapper>
  </div>
</template>

<script setup lang="ts">
import InfoIcon from '~/assets/icons/icon-check.svg?component'
import ClosingIcon from '~/assets/icons/icon-banner-close.svg?component'

const { t } = useI18n()
const { orders, getUserOrders } = useAccount()

const isLoading = ref(false)
const error = ref(null)
const showSuccessBanner = ref(false)

const handleInvoiceSuccess = (data?: {
  has_customer_invoice: boolean
  orderId?: string
}) => {
  // Update the specific order's has_customer_invoice status
  if (data?.has_customer_invoice && data?.orderId) {
    const order = orders.value.find((o) => o.id === data.orderId)
    if (order) {
      order.has_customer_invoice = true
    }
  }
  showSuccessBanner.value = true
}

onMounted(async () => {
  if (orders.value.length) return
  await getUserOrders()
})

definePageMeta({
  middleware: ['auth'],
  requiresAuth: true,
  isSimpleFooter: true,
})
</script>

<style lang="postcss" scoped>
.content {
  :deep(.account-area__content) {
    box-shadow: 0 0 20px 0 rgba(76, 87, 125, 0.06);

    @apply p-2.5 rounded-lg;
  }
}

.success-banner {
  @apply relative py-3.5 bg-success-light z-1 text-sm font-medium flex items-center;
  color: rgba(0, 0, 0, 0.9);

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 100vw;
    z-index: -1;
    top: 0;
    bottom: 0;
    @apply bg-teal-50;
  }

  span {
    @apply mx-5;
  }
}

.icon {
  @apply min-w-[20px];
}

.close {
  @apply ml-auto min-w-[18px];

  :deep(path) {
    fill: black;
  }
}
</style>
